import request from '@/utils/request'

// ==================== 管理员商品管理相关 ====================

/**
 * 创建商品
 * @param {Object} data - 商品数据
 * @returns {Promise}
 */
export function createProduct(data) {
  return request({
    url: '/product/admin/products',
    method: 'post',
    data
  })
}

/**
 * 获取商品详情(管理端)
 * @param {number} productId - 商品ID
 * @returns {Promise}
 */
export function getProduct(productId) {
  return request({
    url: `/product/admin/products/${productId}`,
    method: 'get'
  })
}

/**
 * 更新商品信息
 * @param {number} productId - 商品ID
 * @param {Object} data - 更新数据
 * @returns {Promise}
 */
export function updateProduct(productId, data) {
  return request({
    url: `/product/admin/products/${productId}`,
    method: 'put',
    data
  })
}

/**
 * 商品上下架
 * @param {number} productId - 商品ID
 * @param {Object} data - 状态数据 { is_active: boolean, reason?: string }
 * @returns {Promise}
 */
export function updateProductStatus(productId, data) {
  return request({
    url: `/product/admin/products/${productId}/status`,
    method: 'put',
    data
  })
}

/**
 * 设置会员价格
 * @param {number} productId - 商品ID
 * @param {Object} data - 会员价格数据 { prices: [{ membership_level_id: number, price: number }] }
 * @returns {Promise}
 */
export function updateMembershipPrices(productId, data) {
  return request({
    url: `/product/admin/products/${productId}/membership-prices`,
    method: 'put',
    data
  })
}

/**
 * 查询配置了指定会员等级价格的商品列表
 * @param {number} membershipLevelId - 会员等级ID
 * @returns {Promise}
 */
export function getProductsByMembershipLevel(membershipLevelId) {
  return request({
    url: `/product/admin/products/by-membership-level/${membershipLevelId}`,
    method: 'get'
  })
}

/**
 * 管理员商品列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getAdminProducts(params) {
  return request({
    url: '/product/admin/products',
    method: 'get',
    params
  })
}

/**
 * 删除商品
 * @param {number} productId - 商品ID
 * @returns {Promise}
 */
export function deleteProduct(productId) {
  return request({
    url: `/product/admin/products/${productId}`,
    method: 'delete'
  })
}

/**
 * 获取商品分类列表
 * @returns {Promise}
 */
export function getProductCategories() {
  return request({
    url: '/product/admin/categories',
    method: 'get'
  })
}

// ==================== 用户端商品相关 ====================

/**
 * 用户端商品列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getProducts(params) {
  return request({
    url: '/product/products',
    method: 'get',
    params
  })
}

/**
 * 用户端商品详情
 * @param {number} productId - 商品ID
 * @returns {Promise}
 */
export function getProductDetail(productId) {
  return request({
    url: `/product/products/${productId}`,
    method: 'get'
  })
}

// ==================== 已废弃的API (保留兼容性) ====================

/**
 * @deprecated 已废弃：门店商品管理已改为集中式管理
 * 使用 getAdminProducts 替代
 */
export function getStoreProducts(params) {
  console.warn('getStoreProducts 已废弃，请使用 getAdminProducts')
  return getAdminProducts(params)
}

/**
 * @deprecated 已废弃：不再支持库存管理
 */
export function updateProductStock(productId, data) {
  console.warn('updateProductStock 已废弃，商品系统不再支持库存管理')
  return Promise.reject(new Error('商品系统不再支持库存管理'))
}

/**
 * @deprecated 已废弃：不再支持库存查询
 */
export function getLowStockProducts() {
  console.warn('getLowStockProducts 已废弃，商品系统不再支持库存管理')
  return Promise.reject(new Error('商品系统不再支持库存管理'))
}

/**
 * @deprecated 已废弃：门店分类已改为统一分类管理
 * 使用 getProductCategories 替代
 */
export function getStoreCategories() {
  console.warn('getStoreCategories 已废弃，请使用 getProductCategories')
  return getProductCategories()
}

/**
 * @deprecated 已废弃：批量操作功能暂时不支持
 */
export function batchUpdateProductStatus(data) {
  console.warn('batchUpdateProductStatus 暂时不支持')
  return Promise.reject(new Error('批量操作功能暂时不支持'))
}

/**
 * @deprecated 已废弃：批量删除功能暂时不支持
 */
export function batchDeleteProducts(data) {
  console.warn('batchDeleteProducts 暂时不支持')
  return Promise.reject(new Error('批量操作功能暂时不支持'))
}

/**
 * @deprecated 已废弃：导出功能暂时不支持
 */
export function exportProducts(params) {
  console.warn('exportProducts 暂时不支持')
  return Promise.reject(new Error('导出功能暂时不支持'))
} 